export default __webpack_public_path__ + "static/media/dark.68573fd4.svg";